import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import LiquidationAgreement from 'features/Liquidation/pages/Detail';

function LiquidationAgreementPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <LiquidationAgreement readOnly />
      </Layout>
    </LayoutProvider>
  );
}

export default LiquidationAgreementPage;
